<template>
  <div
    class="fixed flex flex-col left-0 bottom-0 right-0 w-full bg-white z-20 transition-all"
    :class="{
      'h-screen': active
    }">
    <slot
      name="toolbar"
      :active="active"
      :onOpen="onOpen"
      :onClose="onClose"
    ></slot>
    <div v-if="active" class="oder-summary-content max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-12">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderSummary',

  data: () => ({
    active: false,
  }),

  watch: {
    active: {
      immediate: true,
      handler: (active) => {
        if (active) {
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.overflow = null
        }
      }
    }
  },

  unmounted() {
    document.body.style.overflow = null
  },

  methods: {
    onOpen() {
      this.active = true
    },

    onClose() {
      this.active = false
    }
  }
}
</script>

<style scoped>
.oder-summary-content {
  height: calc(100vh - 64px);
  overflow-y: scroll;
}
</style>
